import {
    useMemo,
} from 'react'

import {
    ContractBasisContext,
} from 'app/Apps/Pricing/ContractBasis/hooks/useContractBasisContext'

import SkyNetDataGridExpandable
    from 'app/shared-components/SkyNetDataGridExpandable/SkyNetDataGridExpandable'
import useDataGridSource from 'app/shared-components/SkyNetMasterDataGrid/hooks/useDataGridSource'
import {
    DataGridSupportedFeatures,
} from 'app/shared-components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import AdditionalFeesRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'

import AdditionalFeesCopy from '../AdditionalFeesCopy'
import AdditionalFeesUpdate from '../AdditionalFeesUpdate'
import AdditionalFeesCreate from '../AdditionalFeesCreate'
import columns from './ContractBasisDemoAdditionalFees.columns'

const toolbarControls = [DataGridSupportedFeatures.ShowArchived]

const ContractBasisDemoAdditionalFees = ({
    data,
}: Readonly<{
    data: ContractBasis,
    onSuccess?: () => void,
    onCancel?: () => void,
    backPath?: string,
}>) => {
    const request = useMemo(() => {
        return AdditionalFeesRequests.filterRequestAdditionalFees({
            contractId: data.id,
            params: {},
        })
    }, [data.id])

    const dataSource = useDataGridSource({
        request,
        key: 'contractBasisDemoAdditionalFeesRequest' as RequestKeys,
    })

    const contractBasisContext = useMemo(() => {
        return {
            contractId: data?.id,
            currency: data?.currency,
        }
    }, [data])

    return (
        <ContractBasisContext.Provider value={contractBasisContext}>
            <SkyNetDataGridExpandable
                persistentKey="contract-basis-additional-fees-demo-table"
                columns={columns}
                customDataSource={dataSource}
                toolbarProps={{
                    title: 'Additional Fees',
                    toolbarControls: [],
                }}
                featuresLists={toolbarControls}
                ActionComponents={{
                    Update: {
                        component: AdditionalFeesUpdate,
                    },
                    Copy: {
                        component: AdditionalFeesCopy,
                    },
                    Create: {
                        component: AdditionalFeesCreate,
                        accessOnly: ['contract_basis_create'],
                    },
                }}
            />
        </ContractBasisContext.Provider>
    )
}

export default ContractBasisDemoAdditionalFees
